'use client';

import MainNavBar from './MainNavBar';
import { useUser } from '@auth0/nextjs-auth0/client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { SettingsAppNav } from '~/components/settings/SettingsAppNav';
import { env } from '~/env.mjs';

const isDevBypass = env.NEXT_PUBLIC_DEV_AUTH_BYPASS === true;

export default function NavBar() {
  const { user, isLoading } = useUser();
  const pathname = usePathname();
  const isWorkspaceSettings = pathname?.split('/')[2] === 'settings';

  useEffect(() => {
    // If not loading and no user, redirect to login
    if (!isDevBypass && !isLoading && !user) {
      window.location.href = '/auth/login';
    }
  }, [user, isLoading]);

  // Don't render navbar if user is not authenticated (unless local dev bypass)
  if (!isDevBypass && !user) {
    return null;
  }

  return <div className="flex">{isWorkspaceSettings ? <SettingsAppNav /> : <MainNavBar />}</div>;
}
